import lazyScreen from '../utils/lazyScreen';
const SetupWizard = lazyScreen(() => import('../pages/setting/SetupWizard/index.js'), 'pages/setting/SetupWizard/index.js');
const Setting_WF = lazyScreen(() => import('../pages/setting/wf/index.js'), 'pages/setting/wf/index.js');
const Setting_Sys = lazyScreen(() => import('../pages/setting/sys/index.js'), 'pages/setting/sys/index.js');
const Setting_SysV2 = lazyScreen(() => import('../pages/setting/sys/SysSettingsV2.js'), 'pages/setting/sys/SysSettingsV2.js');
const Setting_SysData = lazyScreen(() => import('../pages/setting/sys/SysData.js'), 'pages/setting/sys/SysData.js');
const SysDataAudits = lazyScreen(() => import('../pages/setting/sys/SysDataAudits/index.js'), 'pages/setting/sys/SysDataAudits/index.js');
const SysDataAudit = lazyScreen(() => import('../pages/setting/sys/SysDataAudit/index.js'), 'pages/setting/sys/SysDataAudit/index.js');
const SysDataBackups = lazyScreen(() => import('../pages/setting/sys/SysDataBackups/index.js'), 'pages/setting/sys/SysDataBackups/index.js');
const SysDataBackup = lazyScreen(() => import('../pages/setting/sys/SysDataBackup/index.js'), 'pages/setting/sys/SysDataBackup/index.js');
const Setting_General = lazyScreen(() => import('../pages/setting/General/index.js'), 'pages/setting/General/index.js');
const Setting_Products = lazyScreen(() => import('../pages/setting/Products/index.js'), 'pages/setting/Products/index.js');
const Setting_Good = lazyScreen(() => import('../pages/setting/Good/Good/index.js'), 'pages/setting/Good/Good/index.js');
const Setting_Material = lazyScreen(() => import('../pages/setting/Material/Material/index.js'), 'pages/setting/Material/Material/index.js');
const Setting_Consumable = lazyScreen(() => import('../pages/setting/Consumable/Consumable/index.js'), 'pages/setting/Consumable/Consumable/index.js');
const Setting_Food = lazyScreen(() => import('../pages/setting/Food/Food/index.js'), 'pages/setting/Food/Food/index.js');
const Setting_Beverage = lazyScreen(() => import('../pages/setting/Beverage/Beverage/index.js'), 'pages/setting/Beverage/Beverage/index.js');
const Setting_ExtraFee = lazyScreen(() => import('../pages/setting/ExtraFee/ExtraFee/index.js'), 'pages/setting/ExtraFee/ExtraFee/index.js');
const Setting_FixedService = lazyScreen(() => import('../pages/setting/FixedService/FixedService/index.js'), 'pages/setting/FixedService/FixedService/index.js');
const Setting_ExpandableService = lazyScreen(() => import('../pages/setting/ExpandableService/ExpandableService/index.js'), 'pages/setting/ExpandableService/ExpandableService/index.js');
const Setting_ServicePack = lazyScreen(() => import('../pages/setting/ServicePack/ServicePack/index.js'), 'pages/setting/ServicePack/ServicePack/index.js');
const Setting_DepositPack = lazyScreen(() => import('../pages/setting/DepositPack/DepositPack/index.js'), 'pages/setting/DepositPack/DepositPack/index.js');
const Setting_DepositPacks = lazyScreen(() => import('../pages/setting/DepositPack/DepositPacks/index.js'), 'pages/setting/DepositPack/DepositPacks/index.js');
const Setting_Variants = lazyScreen(() => import('../pages/setting/Variants/index.js'), 'pages/setting/Variants/index.js');
const Setting_INV = lazyScreen(() => import('../pages/setting/inv/index.js'), 'pages/setting/inv/index.js');
const Setting_ItemWarehouses = lazyScreen(() => import('../pages/setting/ItemWarehouses/index.js'), 'pages/setting/ItemWarehouses/index.js');
const Setting_SPC = lazyScreen(() => import('../pages/setting/spc/index.js'), 'pages/setting/spc/index.js');
const Setting_Store = lazyScreen(() => import('../pages/setting/Store/Store/index.js'), 'pages/setting/Store/Store/index.js');
const Setting_AR = lazyScreen(() => import('../pages/setting/ar/index.js'), 'pages/setting/ar/index.js');
const Setting_Tax = lazyScreen(() => import('../pages/setting/tax/index.js'), 'pages/setting/tax/index.js');
const Setting_ARServe = lazyScreen(() => import('../pages/setting/serve/index.js'), 'pages/setting/serve/index.js');
const Setting_ARCooking = lazyScreen(() => import('../pages/setting/cooking/index.js'), 'pages/setting/cooking/index.js');
const Setting_ItemModifierGroup = lazyScreen(() => import('../pages/setting/modifier/ItemModifierGroup/index.js'), 'pages/setting/modifier/ItemModifierGroup/index.js');
const Setting_ItemModifierProfile = lazyScreen(() => import('../pages/setting/modifier/ItemModifierProfile/index.js'), 'pages/setting/modifier/ItemModifierProfile/index.js');
const Setting_ARRental = lazyScreen(() => import('../pages/setting/rental/index.js'), 'pages/setting/rental/index.js');
const Setting_ARRentalVehicle = lazyScreen(() => import('../pages/setting/rental/RentalVehicle/index.js'), 'pages/setting/rental/RentalVehicle/index.js');
const Setting_ARRentalRoom = lazyScreen(() => import('../pages/setting/rental/RentalRoom/index.js'), 'pages/setting/rental/RentalRoom/index.js');
const Setting_LG = lazyScreen(() => import('../pages/setting/lg/index.js'), 'pages/setting/lg/index.js');
const Setting_AP = lazyScreen(() => import('../pages/setting/ap/index.js'), 'pages/setting/ap/index.js');
const Setting_HRM = lazyScreen(() => import('../pages/setting/hrm/index.js'), 'pages/setting/hrm/index.js');
const Setting_EXP = lazyScreen(() => import('../pages/setting/exp/index.js'), 'pages/setting/exp/index.js');
const Setting_EXR = lazyScreen(() => import('../pages/setting/exr/index.js'), 'pages/setting/exr/index.js');
const Setting_Loyalty = lazyScreen(() => import('../pages/setting/loyalty/index.js'), 'pages/setting/loyalty/index.js');
const Setting_CRM = lazyScreen(() => import('../pages/setting/crm/index.js'), 'pages/setting/crm/index.js');
const Setting_CRMPipeline = lazyScreen(() => import('../pages/setting/crm/CRMPipeline/index.js'), 'pages/setting/crm/CRMPipeline/index.js');
const Setting_CRMLeadAssignRule = lazyScreen(() => import('../pages/setting/crm/CRMLeadAssignRule/index.js'), 'pages/setting/crm/CRMLeadAssignRule/index.js');
const Setting_Commision = lazyScreen(() => import('../pages/setting/coms/index.js'), 'pages/setting/coms/index.js');
const Setting_FA = lazyScreen(() => import('../pages/setting/fa/index.js'), 'pages/setting/fa/index.js');
const Setting_PM = lazyScreen(() => import('../pages/setting/pm/index.js'), 'pages/setting/pm/index.js');
const Setting_MF = lazyScreen(() => import('../pages/setting/mf/index.js'), 'pages/setting/mf/index.js');
const Setting_PNL = lazyScreen(() => import('../pages/setting/pnl/index.js'), 'pages/setting/pnl/index.js');
const Setting_GL = lazyScreen(() => import('../pages/setting/gl/index.js'), 'pages/setting/gl/index.js');
const Setting_CA = lazyScreen(() => import('../pages/setting/ca/index.js'), 'pages/setting/ca/index.js');
const ItemSubstitutes = lazyScreen(() => import('../pages/setting/ItemSubstitutes/index.js'), 'pages/setting/ItemSubstitutes/index.js');
const ItemSubstitute = lazyScreen(() => import('../pages/setting/ItemSubstitute/index.js'), 'pages/setting/ItemSubstitute/index.js');
const Setting_AIConfig = lazyScreen(() => import('../pages/setting/ai/AIConfig/index.js'), 'pages/setting/ai/AIConfig/index.js');

export default [
    {
        path: '/setup-wizard',
        component: SetupWizard
    },
    {
        path: '/setting/sys',
        component: Setting_SysV2
    },
    {
        path: '/setting/sys-v2',
        component: Setting_SysV2
    },
    {
        path: '/setting/sys/data',
        component: Setting_SysData
    },
    {
        path: '/setting/sys/SysDataAudits',
        component: SysDataAudits
    },
    {
        path: '/setting/sys/SysDataAudit/:code',
        component: SysDataAudit
    },
    {
        path: '/setting/sys/SysDataBackups',
        component: SysDataBackups
    },
    {
        path: '/setting/sys/SysDataBackup/:code',
        component: SysDataBackup
    },
    {
        path: '/setting/General',
        component: Setting_General
    },
    {
        path: '/setting/Integration',
        component: Setting_General
    },
    {
        path: '/setting/Products',
        component: Setting_Products
    },
    {
        path: '/setting/Good/:code',
        component: Setting_Good
    },
    {
        path: '/setting/Material/:code',
        component: Setting_Material
    },
    {
        path: '/setting/Consumable/:code',
        component: Setting_Consumable
    },
    {
        path: '/setting/Food/:code',
        component: Setting_Food
    },
    {
        path: '/setting/Beverage/:code',
        component: Setting_Beverage
    },
    {
        path: '/setting/ExtraFee/:code',
        component: Setting_ExtraFee
    },
    {
        path: '/setting/FixedService/:code',
        component: Setting_FixedService
    },
    {
        path: '/setting/ExpandableService/:code',
        component: Setting_ExpandableService
    },
    {
        path: '/setting/ServicePack/:code',
        component: Setting_ServicePack
    },
    {
        path: '/setting/DepositPacks',
        component: Setting_DepositPacks
    },
    {
        path: '/setting/DepositPack/:code',
        component: Setting_DepositPack
    },
    // {
    //     path: '/setting/items',
    //     component: Setting_Items
    // },
    // {
    //     path: '/setting/item/:code',
    //     component: Setting_Item
    // },
    {
        path: '/setting/Variants',
        component: Setting_Variants
    },
    {
        path: '/setting/inv',
        component: Setting_INV
    },
    {
        path: '/setting/ItemWarehouses',
        component: Setting_ItemWarehouses
    },
    {
        path: '/setting/spc',
        component: Setting_SPC
    },
    {
        path: '/setting/Store/:code',
        component: Setting_Store
    },
    {
        path: '/setting/ar',
        component: Setting_AR
    },
    {
        path: '/setting/tax',
        component: Setting_Tax
    },
    // Bí danh của trang thiết lập thuế cho mục "Thiết lập hóa đơn điện tử" (HD-04) của thực đơn Kế toán:
    // kit dò nhóm thực đơn theo đường dẫn nên hai mục không được dùng chung '/setting/tax'.
    {
        path: '/setting/einvoice',
        component: Setting_Tax
    },
    {
        path: '/setting/serve',
        component: Setting_ARServe
    },
    {
        path: '/setting/cooking',
        component: Setting_ARCooking
    },
    {
        path: '/setting/ItemModifierGroup/:code',
        component: Setting_ItemModifierGroup
    },
    {
        path: '/setting/ItemModifierProfile/:code',
        component: Setting_ItemModifierProfile
    },
    {
        path: '/setting/rental',
        component: Setting_ARRental
    },
    {
        path: '/setting/RentalVehicle/:code',
        component: Setting_ARRentalVehicle
    },
    {
        path: '/setting/RentalRoom/:code',
        component: Setting_ARRentalRoom
    },
    {
        path: '/setting/lg',
        component: Setting_LG
    },
    {
        path: '/setting/ap',
        component: Setting_AP
    },
    {
        path: '/setting/hrm',
        component: Setting_HRM
    },
    {
        path: '/setting/exp',
        component: Setting_EXP
    },
    {
        path: '/setting/exr',
        component: Setting_EXR
    },
    {
        path: '/setting/loyalty',
        component: Setting_Loyalty
    },
    {
        path: '/setting/crm',
        component: Setting_CRM
    },
    {
        path: '/setting/CRMPipeline/:id',
        component: Setting_CRMPipeline
    },
    {
        path: '/setting/CRMLeadAssignRule/:id',
        component: Setting_CRMLeadAssignRule
    },

    {
        path: '/setting/coms',
        component: Setting_Commision
    },
    {
        path: '/setting/pm',
        component: Setting_PM
    },
    {
        path: '/setting/fa',
        component: Setting_FA
    },
    {
        path: '/setting/mf',
        component: Setting_MF
    },
    {
        path: '/setting/pnl',
        component: Setting_PNL
    },
    {
        path: '/setting/gl',
        component: Setting_GL
    },
    {
        path: '/setting/ca',
        component: Setting_CA
    },
    {
        path: '/setting/wf',
        component: Setting_WF
    },
    {
        path: '/setting/ItemSubstitutes',
        component: ItemSubstitutes
    },
    {
        path: '/setting/ItemSubstitute/:id',
        component: ItemSubstitute
    },
    {
        path: '/setting/ai/AIConfig',
        component: Setting_AIConfig
    }
];
